import axios from 'axios';
import { AppConfigValues } from '../../common/types';
import { isProdBuild } from './isProdBuild';

const PRODUCTION_CONFIG_VALUES_URL = `${process.env.REACT_APP_PUBLIC_URL}/.configs`;

export const getConfigValuesFromEnv = async (): Promise<AppConfigValues> => {
  if (!isProdBuild()) {
    try {
      return JSON.parse(process.env.REACT_APP_CONFIG_VALUES);
    } catch (error) {}
  }

  const fetchResult = await axios.get<AppConfigValues>(PRODUCTION_CONFIG_VALUES_URL);

  return fetchResult.data;
};
